module.exports = __webpack_public_path__ + "img/kerneis.c565ac09.jpg";